import { CircularProgress } from "@mui/material";

/**
 * Neutral full-page placeholder. Shown until we know which print house (and therefore which
 * branding) the invite belongs to, so an HP invitee never sees GoMake-branded content.
 */
const InviteSplash = () => (
  <div
    style={{
      minHeight: "100vh",
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "#ffffff",
    }}
  >
    <CircularProgress size={28} />
  </div>
);

export { InviteSplash };
